import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MenuList, MenuItem, Paper } from "@mui/material";
import ContextMenu from "../ContextMenu/ContextMenu";
import { useDispatch, useSelector } from "react-redux";
import { treeActions } from "../../redux/slices/treeSlice";
import { getNewRecordName, getUpdatedData } from "./ContextActions/NewRecord";
import { cloneDeep } from "lodash";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { genKey } from "../../utils/utilFunctions";
import CopyAndPaste from "./ContextActions/CopyAndPaste";

function BlankJSONMenu(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const parentScreen = useContext(ParentScreenCtx);
  const { type } = useSelector((state) => state.treeData[parentScreen].leftTree.tree.body.selectedNode);
  const { tree, currentTab } = useSelector((state) => state.treeData[parentScreen].rightTree);
  const translatedData = tree.body.translatedData;
  const templateHeader = useSelector(
    (state) => state.treeData[parentScreen].rightTree.tree.templateHeader
  );
  const {isCopied,setIsCopied} = props;

  function newRecordHandler() {

    // Finding Latest Key in
    const getNewRecordData=(data)=>{

      const newRecordName = getNewRecordName(tree);

      return {key:"ib-0-0-0",TYPE:newRecordName,ICON_DISPLAY:"RECORD"} ;
    }

    // Creating new Record in Redux
    const nodeDetail = translatedData[0]?.children?.length? getNewRecordData(translatedData[0]?.children) : {TYPE:"root",ICON_DISPLAY:"RECORD_TOP",key:'ib-0-0'}
    const titleType = currentTab.charAt(0).toUpperCase() + currentTab.substr(1).toLowerCase();
    const title = nodeDetail.title + (currentTab!='body' ? `_${titleType}` : "")
    const newNode = {
      nodeId:genKey(nodeDetail.title),
      key: nodeDetail.key,
      title: nodeDetail.TYPE,
      ICON_DISPLAY: nodeDetail.ICON_DISPLAY,
      type: nodeDetail.ICON_DISPLAY,
      TYPE:nodeDetail.TYPE,
      children: [],
    };

    const newTranslatedData = cloneDeep(translatedData);

    if(newTranslatedData[0]?.children?.length){
      newTranslatedData[0]?.children[0].children.splice(0,0,newNode);
    }else{
      newTranslatedData[0]?.children.push(newNode);
    }
    // console.log(newTranslatedData);
    const updatedData = getUpdatedData(newTranslatedData,templateHeader?.FILETYPE);
    dispatch(
      treeActions.setNewRightTreeTranslatedData({
        screen: parentScreen,
        type: currentTab,
        data: updatedData,
      })
    );
    dispatch(treeActions.setRightTreeSelectedNode({screen: parentScreen, type:currentTab, data:newNode }));
  }

  function showMenuOrNot() {
    //Checking if template is Empty or Not.
    const isTemplateEmpty =
      currentTab === "body"
        ? tree[currentTab]?.translatedData[0]?.children?.length === 0 ||
          tree[currentTab].selectedNode.ICON_DISPLAY === "TEMPLATE_BODY_DOTS"
        : tree[currentTab]?.translatedData?.length === 0;

    //Checking if body node is Selected or not;
    const nodeSelected =
      currentTab === "body"
        ? Object.keys(tree[currentTab].selectedNode).length > 0
        : true;
    return isTemplateEmpty && nodeSelected;
    
  }

  return (
    <>
      {type === "inboundTemplate" &&
      showMenuOrNot() &&
      !Array.isArray(templateHeader) ? (
        <ContextMenu targetId="rightTree">
          <Paper elevation={3} sx={{ width: "19rem" }}>
            <MenuList>
              <MenuItem name={t("MNU_NEW_OBJECT")} onClick={newRecordHandler}>
                <span className={"NEW_OBJECT"}></span>
                <span className={"margin-left-8"}>{t("MNU_NEW_OBJECT")}</span>
              </MenuItem>
            </MenuList>
          </Paper>
        </ContextMenu>
      ) : (
        ""
      )}
      <CopyAndPaste isCopied={isCopied} setIsCopied={setIsCopied} contextMenuType={isCopied.dispatchFrom === "keyPress" ? isCopied.dispatchFrom : "BlankJSONMenu"} treeType={parentScreen}/>
    </>
  );
}

export default BlankJSONMenu;
